define('shared/util/imageMetaReady',['shared/lib/RSVP'], function(RSVP){
    'use strict';
    var requestAnimationFrame = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        function (fn) {
            return window.setTimeout(fn, 20);
        };

    return function (el){
        function loop(callback) {
            if (el.naturalWidth && el.naturalHeight) {
                return callback();
            }
            else {
                requestAnimationFrame(function(){
                    loop(callback);
                });
            }
        }

        return new RSVP.Promise(function(rs){
            loop(rs);
        });
    };
});
